import { Component, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { MatCardModule } from '@angular/material/card';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';

import { AppService } from '@app/app.service';
import { LoadingOverlayService } from '@app/shared/loading-overlay/loading-overlay.service';
import { MatDialog } from '@angular/material/dialog';
import { UserViewDialogComponent } from './user-view-dialog/user-view-dialog.component';

@Component({
  selector: 'app-users',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
  ],
  templateUrl: './users.html',
  styleUrl: './users.scss',
})
export class Users implements OnInit, AfterViewInit {

  displayedColumns: string[] = [
    'actions',
    'name',
    'email',
    'role',
    'created_at',
    'updated_at',
    'last_login_at',
    'last_active_at',
  ];

  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatSort) sort?: MatSort;
  @ViewChild(MatPaginator) paginator?: MatPaginator;

  constructor(
    private appService: AppService,
    private loadingOverlay: LoadingOverlayService,
    private router: Router,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      switch (property) {
        case 'name':
          return item.name ?? `${item.first_name ?? ''} ${item.last_name ?? ''}`;
        case 'email':
          return item.email ?? '';
        case 'role':
          return item.role ?? '';
        case 'created_at':
          return item.created_at ?? '';
        case 'updated_at':
          return item.updated_at ?? '';
        case 'last_login_at':
          return item.last_login_at ?? '';
        case 'last_active_at':
          return item.last_active_at ?? '';
        default:
          return item[property] ?? '';
      }
    };

    this.getUsers();
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort ?? null;
    this.dataSource.paginator = this.paginator ?? null;
  }

  getUsers(): void {
    this.loadingOverlay.show();

    this.appService.getUsers().subscribe({
      next: (res) => {
        this.dataSource.data = res.data ?? res ?? [];
        this.loadingOverlay.hide();
      },
      error: (err) => {
        this.loadingOverlay.hide();
        this.appService.errorSnackBar(err?.error?.message ?? 'Failed to load users');
      },
    });
  }

  getUserName(user: any): string {
    if (user.name) return user.name;

    const fullName = `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim();

    return fullName || 'N/A';
  }

  openUserDetails(user: any): void {
    this.dialog.open(UserViewDialogComponent, {
      width: '500px',
      data: user,
    });
  }

  goBack(): void {
    this.router.navigate(['/dashboard']);
  }
}